/* eslint-disable */
import cityFilter from '../components/city-filter';

export function initCityFilter() {
    cityFilter();
    jQuery(document).on('ajaxComplete', cityFilter);
}
